// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Cq8y_","location":"Header_location__3Z9UY"};